import { render, staticRenderFns } from "./OrderCleaningAddons.vue?vue&type=template&id=a5d1a638&scoped=true"
import script from "./OrderCleaningAddons.vue?vue&type=script&lang=js"
export * from "./OrderCleaningAddons.vue?vue&type=script&lang=js"
import style0 from "./OrderCleaningAddons.vue?vue&type=style&index=0&id=a5d1a638&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5d1a638",
  null
  
)

export default component.exports